import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, MaybeAsync, GuardResult } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { MsalBroadcastService, MsalService } from "@azure/msal-angular";
import { AccountInfo, InteractionStatus } from "@azure/msal-browser";
import { AppRoles } from "./interfaces";

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

    constructor(
        private readonly authService: MsalService,
        private readonly msalBroadcastService: MsalBroadcastService
    ) { }
    
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
        return this.msalBroadcastService.inProgress$.pipe(
        filter(status => status === InteractionStatus.None),
        take(1),
        map(() => {        
            const expectedRoles: AppRoles[] = route.data?.['roles'] as AppRoles[];        
            const account: AccountInfo = this.authService.instance.getAllAccounts()[0];        

            if (!account) {
            return false;
            }

            if (!expectedRoles || expectedRoles.length === 0) {
            return true;
            }

            const userRoles: string[] = account.idTokenClaims?.roles || [];
            const hasRequiredRole = expectedRoles.some(role => userRoles.includes(role));

            if (!userRoles.length) {          
            alert("Você não possui permissões atribuídas à aplicação.");
            return false;
            }

            if (!hasRequiredRole) {
            alert("Parece que sua conta ainda não tem as permissões necessárias para acessar esse recurso.");
            return false;
            }

            return true;
        })
        );
    }
}
